<template>
	<div class="bb-panel-wrapper">
		<div class="loading-campaign" v-if="campaignLoading">
			<loading-icon></loading-icon>
		</div>
		<section class="b360-section-container" v-else>
			<span class="b360-form-label" role="heading">Media Type</span>
			<BbMediaPicker
				v-for="(groupType, index) in mediaTypeArray"
				:icon="groupType.icon"
				:icon-weight="groupType.iconWeight"
				:key="index"
				:groupType="groupType"
				:value="groupType.value"
				:radioKey="groupType.index"
			/>
		</section>
		<section class="b360-section-container" v-if="selectedMediaType !== null">
			<span class="b360-form-label" role="heading">Audience Type</span>
			<BbMediaPicker
				v-for="(groupType, index) in audienceTypeArray"
				:icon="groupType.icon"
				:icon-weight="groupType.iconWeight"
				:key="index"
				:groupType="groupType"
				:value="groupType.value"
				:radioKey="groupType.index"
			/>
		</section>
		<button
			class="b360-btn b360-btn--workspace-primary"
			@click="nextStep()"
			:class="{ disabled: selectedAudienceType === null }"
			:disabled="selectedAudienceType === null"
		>
			Next Step
		</button>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BbMediaPicker from '@/components/brand-builder/BbMediaPicker.vue';
import LoadingIcon from '@/components/global/LoadingIcon.vue';
import { MEDIA_ID } from '@/constants/brand-builder';

export default {
	name: 'BbMediaType',
	components: {
		BbMediaPicker,
		LoadingIcon,
	},
	methods: {
		...mapState({ userInPilot: (state) => state.profile.isPilotUser }),
		...mapActions([
			'selectMediaType',
			'selectAudienceType',
			'completeVideoAction',
			'initialCampaignSelections',
			'setRouteAllowed',
			'setClientConnectAlertEmailDetails',
		]),
		nextStep() {
			switch (this.selectedMediaType) {
				case MEDIA_ID.POWERPOINT:
				case MEDIA_ID.VIDEO:
					this.$router.push({
						path: `/campaign-editor-workspace/${this.$route.params.campaignId}/design`,
					});
					break;
				case MEDIA_ID.PRICING_FLYER:
					// This scenario should not happen
					this.$router.push({
						path: `/campaign-editor-workspace/${this.$route.params.campaignId}/pricing`,
					});
					break;
				default:
					this.$router.push({
						path: `/campaign-editor-workspace/${this.$route.params.campaignId}/text`,
					});
			}
		},
	},
	computed: mapState({
		campaignLoading: (state) => state.brandBuilderEditor.campaignLoading,
		selectedAudienceType: (state) =>
			state.brandBuilderEditor.selectedAudienceType,
		mediaTypeArray: (state) => {
			// Find all of the Media Types that are supported in this Campaign
			let mediaTypes = state.brandBuilderEditor.campaignItems
				.map((x) => x.itemType.itemTypeId)
				.filter((value, index, self) => self.indexOf(value) === index);

			// eslint-disable-next-line prefer-destructuring
			const permissionsList = state.preferenceCenterPermissions.permissionsList;
			if (state.profile.isPilotUser) {
				//if in pilot, no email
				mediaTypes = mediaTypes.filter((x) => x !== MEDIA_ID.EMAIL);
			}
			if (
				!permissionsList ||
				!permissionsList.some((p) => p === 'AbilityToPostToSocial')
			) {
				// Remove social if they don't have permission
				mediaTypes = mediaTypes.filter((x) => x !== MEDIA_ID.SOCIAL_MEDIA);
			}
			if (
				!permissionsList ||
				!permissionsList.some((p) => p === 'AbilityToSendEmails')
			) {
				// Remove email if no permission
				mediaTypes = mediaTypes.filter((x) => x !== MEDIA_ID.EMAIL);
			}
			// Return all of the Base Media Types, and only return the items which are supported by this
			return state.brandBuilderEditor.mediaTypeArray.filter(
				(x) => mediaTypes.indexOf(x.index) >= 0,
			);
		},
		audienceTypeArray: (state) => {
			// Find all of the Audience Types that are supported in this Campaign
			const audienceTypes = state.brandBuilderEditor.campaignItems
				.filter(
					(x) =>
						x.itemType.itemTypeId ===
						state.brandBuilderEditor.selectedMediaType,
				)
				.flatMap((x) => x.audiences.flatMap((y) => y.audienceId))
				.filter((value, index, self) => self.indexOf(value) === index);

			// Return all of the Base Audience Types, and only return the items which are supported by this campaign
			return state.brandBuilderEditor.audienceTypeArray.filter(
				(x) => audienceTypes.indexOf(x.index) >= 0,
			);
		},
		selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
	}),
	watch: {
		selectedAudienceType() {
			if (this.selectedAudienceType !== null) {
				this.initialCampaignSelections();
			} else {
				this.setRouteAllowed({ route: 'all', activated: false });
			}
		},
	},
	mounted() {
		/* TODO: Refactor onreadystatechange this.  This will likely never get called
    since the page already loaded before this event registered. */
		document.onreadystatechange = () => {
			if (document.readyState === 'complete') {
				this.selectMediaType(
					this.$store.state.brandBuilderEditor.mediaTypeArray[0],
				);
			}
		};
		this.completeVideoAction(null);
	},
};
</script>

<style lang="scss" scoped>
.loading-campaign {
	margin: 1rem auto;
	text-align: center;
}
</style>
